module.exports = __webpack_public_path__ + "img/lijing.eb90fd2a.jpg";